// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconApps, IconUsers, IconUserExclamation, IconDeviceAnalytics, IconRefresh } from '@tabler/icons';

// constant
const icons = { IconApps, IconUsers, IconUserExclamation, IconDeviceAnalytics, IconRefresh };

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: <FormattedMessage id="dashboard" />,
    caption: <FormattedMessage id="dashboard-caption" />,
    icon: icons.IconKey,
    type: 'group',
    permission: 2,
    children: [
        {
            id: 'users-managment',
            title: <FormattedMessage id="users-managment" />,
            type: 'item',
            icon: icons.IconUsers,
            url: '/dashboard/users-managment',
            breadcrumbs: true
        },
        {
            id: 'online-users',
            title: <FormattedMessage id="online-users" />,
            type: 'item',
            icon: icons.IconUserExclamation,
            url: '/dashboard/online-users',
            breadcrumbs: true
        },
        {
            id: 'server-monitoring',
            title: <FormattedMessage id="server-monitoring" />,
            type: 'item',
            icon: icons.IconDeviceAnalytics,
            url: '/dashboard/server-monitoring',
            breadcrumbs: true
        },
        {
            id: 'server-update',
            title: <FormattedMessage id="server-update" />,
            type: 'item',
            icon: icons.IconRefresh,
            url: '/dashboard/server-update',
            breadcrumbs: true
        },
    ]
};

export default dashboard;
